module.exports = "/_next/static/videos/02-video-d2a046a04121b224d12318d6e45f6f45.mp4";